import urlConstants from '~/lib/constants/url.constants';
import api from '~/store/services/api';

import { HttpRequestMethod } from '..';

const { techOps } = urlConstants;

export const techOpsApi = api.injectEndpoints({
  endpoints: (build) => ({
    bulkProviderTeamAssignments: build.mutation<
      OpsBulkProviderJobResponse,
      FormData
    >({
      query: (formData) => ({
        body: formData,
        method: HttpRequestMethod.POST,
        url: techOps.bulkProviderTeamAssignments,
      }),
    }),
    getBulkProviderTeamAssignmentsByJobKey: build.query<
      OpsBulkJobStatusResponse,
      string
    >({
      query: (jobKey) => ({
        url: techOps.bulkProviderTeamAssignmentsByJobKey(jobKey),
      }),
    }),
    getBulkProviderTeamAssignmentsLatestJob: build.query<
      OpsBulkProviderJobResponse,
      void
    >({
      query: () => ({
        url: techOps.bulkProviderTeamAssignmentsLatestJob,
      }),
    }),
  }),
});

export const {
  useBulkProviderTeamAssignmentsMutation,
  useGetBulkProviderTeamAssignmentsByJobKeyQuery,
  useGetBulkProviderTeamAssignmentsLatestJobQuery,
  useLazyGetBulkProviderTeamAssignmentsByJobKeyQuery,
  useLazyGetBulkProviderTeamAssignmentsLatestJobQuery,
} = techOpsApi;
